import rootReducer from '../reducer'
import {createStore} from 'redux'

// import {createLogger} from "redux-logger"
// import thunkMiddleware from "redux-thunk"
// export const store = createStore(rootReducer, applyMiddleware(thunkMiddleware)) // , loggerMiddleware

const store = createStore(rootReducer)
export default store
